import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
// import './App.css';
import Home from './components/home';
import SplashScreen from './components/splash_screen';
import About from './components/about';
import Register from './components/register';
import ContactUs from './components/contactUs';
import CategoryHeader from './components/article';
import AnimalInfoParent from './components/animalInfo';
import Gallery from './components/gallery';
import Dashboard from './components/admin/dashboard';
import AdminLogin from './components/admin/adminLogin';
import AdminCategory from './components/admin/category';
import AdminUserData from './components/admin/userData';
import UserProfileEdit from './components/admin/profileEdit';
import Error404 from './components/error404';
import Details from './components/details';


function App() {
  return (

    <>
	<BrowserRouter>

		<Routes>
			<Route path='' element={<SplashScreen/>}></Route>
			<Route path='/home' element={<Home/>}></Route>
			<Route path='/about' element={<About/>}></Route>
			<Route path='/register' element={<Register/>}></Route>
			<Route path='/contact' element={<ContactUs/>}></Route>
			<Route path='/gallery' element={<Gallery/>}></Route>
			<Route path='/article' element={<CategoryHeader/>}></Route>
			<Route path='/category_amphibian' element={<AnimalInfoParent title={'Amphibians'} slogan={'Masters of Both Worlds!'}/>}></Route>
			<Route path='/category_birds' element={<AnimalInfoParent title={'Birds'} slogan={'Nature\'s Aerial Delight!'}/>}></Route>
			<Route path='/category_mammals' element={<AnimalInfoParent title={'Mammals'} slogan={' Nature\'s Cuddly Art!'}/>}></Route>
			<Route path='/category_marines' element={<AnimalInfoParent title={'Marines'} slogan={'Creatures of the Deep!'}/>}></Route>
			<Route path='/category_reptiles' element={<AnimalInfoParent title={'Reptiles'} slogan={'Scaled Wonders, Ancient and Bold!'}/>}></Route>
			<Route path='/category_endangered' element={<AnimalInfoParent title={'Endangered'} slogan={' A Cause We Must Connect!'}/>}></Route>
			<Route path='/animal_detail' element={<Details/>}></Route>


			<Route path='/admin' element={<Dashboard/>}></Route>
			<Route path='/admin_login' element={<AdminLogin/>}></Route>
			<Route path='/admin_category' element={<AdminCategory/>}></Route>
			<Route path='/admin_table_amphibians' element={<AdminCategory heading={'Amphibians'}/>}></Route>
			<Route path='/admin_table_birds' element={<AdminCategory heading={'Birds'}/>}></Route>
			<Route path='/admin_table_mammals' element={<AdminCategory heading={'Mammals'}/>}></Route>
			<Route path='/admin_table_marines' element={<AdminCategory heading={'Marines'}/>}></Route>
			<Route path='/admin_table_reptiles' element={<AdminCategory heading={'Reptiles'}/>}></Route>
			<Route path='/admin_table_endangered' element={<AdminCategory heading={'Endangered'}/>}></Route>
			<Route path='/admin_user_data' element={<AdminUserData/>}></Route>
			<Route path='/admin_user_edit' element={<UserProfileEdit/>}></Route>



			<Route path='/pageNotFound' element={<Error404/>}></Route>
			<Route path='*' element={<Navigate to="/pageNotFound"/>}></Route>

			
		</Routes>
		
	</BrowserRouter>
	</>
  );
}

export default App;
